"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreCache = exports.VENV_PATH = exports.WORKING_DIR_PATH = exports.STATE_CACHE_MATCHED_KEY = exports.STATE_CACHE_KEY = void 0;
const crypto = __importStar(require("crypto"));
const cache = __importStar(require("@actions/cache"));
const glob = __importStar(require("@actions/glob"));
const core = __importStar(require("@actions/core"));
const fs = __importStar(require("fs"));
const path_1 = __importDefault(require("path"));
const io_1 = require("@actions/io/");
const io_util_1 = require("@actions/io/lib/io-util");
const utils_1 = require("./utils");
exports.STATE_CACHE_KEY = 'cache-key';
exports.STATE_CACHE_MATCHED_KEY = 'cache-matched-key';
const workingDirInput = core.getInput('working-directory');
const workingDir = workingDirInput ? `${path_1.default.sep}${workingDirInput}` : '';
exports.WORKING_DIR_PATH = `${process.env['GITHUB_WORKSPACE']}${workingDir}`;
exports.VENV_PATH = `${process.env['GITHUB_WORKSPACE']}${workingDir}${path_1.default.sep}.venv`;
const CACHE_VERSION = '5';
const cacheLocalStoragePath = `${core.getInput('cache-local-storage-path')}` || '';
const cacheDependencyPath = `${process.env['GITHUB_WORKSPACE']}${workingDir}${path_1.default.sep}${path_1.default.sep}requirements**.lock`;
function restoreCache(cachePrefix, version) {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheKey = yield computeKeys(cachePrefix, version);
        if (cacheKey.endsWith('-')) {
            throw new Error(`No file in ${process.cwd()} matched to [${cacheDependencyPath}], make sure you have checked out the target repository`);
        }
        let matchedKey;
        core.info(`Trying to restore .venv from cache with key: ${cacheKey}`);
        try {
            matchedKey = cacheLocalStoragePath
                ? yield restoreCacheLocal(cacheKey)
                : yield cache.restoreCache([exports.VENV_PATH], cacheKey);
        }
        catch (err) {
            const message = err.message;
            core.warning(message);
            core.setOutput('cache-hit', false);
            return;
        }
        core.saveState(exports.STATE_CACHE_KEY, cacheKey);
        handleMatchResult(matchedKey, cacheKey);
    });
}
exports.restoreCache = restoreCache;
function computeKeys(cachePrefix, version) {
    return __awaiter(this, void 0, void 0, function* () {
        const cacheDependencyPathHash = yield glob.hashFiles(cacheDependencyPath);
        const workingDirHash = workingDir
            ? `-${crypto.createHash('sha256').update(workingDir).digest('hex')}`
            : '';
        const prefix = cachePrefix ? `${cachePrefix}-` : '';
        return `${prefix}setup-rye-${CACHE_VERSION}-${process.env['RUNNER_OS']}-${(0, utils_1.getArch)()}-rye-${version}${workingDirHash}-${cacheDependencyPathHash}`;
    });
}
function handleMatchResult(matchedKey, primaryKey) {
    if (!matchedKey) {
        core.info(`No${cacheLocalStoragePath ? ' local' : ''} cache found for key: ${primaryKey}`);
        core.setOutput('cache-hit', false);
        return;
    }
    const venvPathMatch = doesCachedVenvPathMatchCurrentVenvPath();
    if (!venvPathMatch) {
        fs.rmSync(exports.VENV_PATH, { recursive: true });
        core.setOutput('cache-hit', false);
        return;
    }
    core.saveState(exports.STATE_CACHE_MATCHED_KEY, matchedKey);
    core.info(`.venv restored from${cacheLocalStoragePath ? ' local' : ''} cache with key: ${matchedKey}`);
    core.setOutput('cache-hit', true);
}
function doesCachedVenvPathMatchCurrentVenvPath() {
    const ryeVenvPath = `${exports.VENV_PATH}${path_1.default.sep}rye-venv.json`;
    const ryeVenv = JSON.parse(fs.readFileSync(ryeVenvPath, 'utf8'));
    core.info(`Checking if the cached .venv matches the current path: ${exports.VENV_PATH}`);
    if (ryeVenv.venv_path !== exports.VENV_PATH) {
        core.warning(`The .venv in the cache cannot be used because it is from another location: ${ryeVenv.venv_path}`);
        return false;
    }
    return true;
}
function restoreCacheLocal(primaryKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const storedCache = `${cacheLocalStoragePath}${path_1.default.sep}${primaryKey}`;
        if (yield (0, io_util_1.exists)(storedCache)) {
            yield (0, io_1.cp)(`${storedCache}${path_1.default.sep}.venv`, exports.VENV_PATH, {
                recursive: true
            });
            return primaryKey;
        }
    });
}
